var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41232 12.4002C4.83541 12.7736 5.39116 13.0002 5.99984 13.0002C6.60852 13.0002 7.16427 12.7736 7.58736 12.4002M9.59989 4.60005C9.59989 3.64526 9.2206 2.72957 8.54546 2.05443C7.87032 1.37929 6.95463 1 5.99984 1C5.04505 1 4.12936 1.37929 3.45422 2.05443C2.77908 2.72957 2.39979 3.64526 2.39979 4.60005C2.39979 6.45419 1.93207 7.72367 1.40957 8.56335C0.968846 9.27164 0.748482 9.62578 0.756562 9.72457C0.765509 9.83396 0.788684 9.87568 0.876834 9.94107C0.956445 10.0001 1.31533 10.0001 2.0331 10.0001H9.96658C10.6843 10.0001 11.0432 10.0001 11.1228 9.94107C11.211 9.87568 11.2342 9.83396 11.2431 9.72457C11.2512 9.62578 11.0308 9.27164 10.5901 8.56335C10.0676 7.72367 9.59989 6.45419 9.59989 4.60005Z",
    stroke: "#FF0082",
    strokeWidth: 1.20002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8a3bf9dacf9460402269742234020eb1.svg";
export { ForwardRef as ReactComponent };